var _path, _path2, _path3, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 199.078l512 207.183v-46.67l-238.768-94.393L0 152.412z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M512 359.588v-46.665L0 105.739v46.673"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#d80027"
}, /*#__PURE__*/React.createElement("path", {
  d: "M304.224 237.452c0 26.633-21.591 48.224-48.224 48.224s-48.224-21.591-48.224-48.224a48.002 48.002 0 015.796-22.94c-10.465 10.702-16.925 25.337-16.925 41.488 0 32.779 26.573 59.353 59.353 59.353s59.353-26.574 59.353-59.353c0-16.15-6.46-30.786-16.925-41.488a48.002 48.002 0 015.796 22.94z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M244.87 181.805h22.258v111.282H244.87z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M293.095 204.066h-74.191c0 5.122 4.461 9.274 9.583 9.274h-.309a9.274 9.274 0 009.274 9.274 9.274 9.274 0 009.274 9.274h18.548a9.274 9.274 0 009.274-9.274 9.274 9.274 0 009.274-9.274h-.308c5.119 0 9.581-4.151 9.581-9.274zm-89.03 96.445h103.869v22.258H204.065z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M278.261 307.935h44.514v22.258h-44.514zm-89.032 0h44.514v22.258h-44.514z"
}))));

export default SvgBn;